import { Provider, Type } from '@angular/core';
import { GroupInfoDialogService } from './group-info-dialog.service';

export const provideGroupInfoDialog = <T extends GroupInfoDialogService>(
    implementation: Type<T>,
): Provider => ({
    provide: GroupInfoDialogService,
    useClass: implementation,
});
